<script>
    import {formatDate, millisecondsToHours, pad0, setFocusTo} from "../../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';
    import Notifier from "../../stores/notifier";

    export let duration = null;
    export let disabled = false;
    export let css = null;

    let time = null;

    const dispatch = createEventDispatcher();

    const onChange = (event) => {
        console.log("onDurationChange", event.target.value);
        let [hours, minutes, seconds] = event.target.value.split(":");
        if (!seconds) seconds = 0;
        if (!minutes) minutes = 0;

        if (!hours && !minutes && !seconds) {
            Notifier.showError("Ο χρόνος δεν είναι έγκυρος!");
            return;
        }

        duration = parseInt(seconds) * 1000 + parseInt(minutes) * 60 * 1000 + parseInt(hours) * 60 * 60 * 1000;
        dispatch('change', duration);
        // time = millisecondsToHours(duration);
        //
        // console.log("D", milliseconds, duration);
        //
        // console.log("startAt", startAt, "endAt", endAt);
        // let dt = new Date(startAt);
        //
        // dt.setMilliseconds(dt.getMilliseconds() + milliseconds);
        // endAt = formatDate(dt, 'y-m-d H:i:s');
        // console.log(endAt);


    }

    const onKeyup = (event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            time = millisecondsToHours(duration);
        }
    }

    $: {
        if (duration != null) {
            time = millisecondsToHours(duration);
        }
    }
</script>

<input type="text" class="form-control duration-control { css }" value="{ time }" maxlength="8" on:change="{ onChange }" on:keyup="{ onKeyup }" {disabled}>


<style>
    .duration-control {
        font-weight: 500;
        font-size: 1.1rem;
        letter-spacing: 0;
        text-align: center;
        padding: 0.301rem 0.75rem;
    }
</style>